import template from './dashboard-filter.component.html';

export const DashboardFilterComponent = {
	name: 'mxDashboardFilter',
	controller: function () {},
	controllerAs: 'vm',
	template,
	bindings: {
		filter: '<',
	},
};
